import { inject, Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { NzNotificationService } from 'ng-zorro-antd/notification';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorNotificationsInterceptor implements HttpInterceptor {
  constructor() {
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    try {
      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.error instanceof ErrorEvent) {
            throw error;
          }

          const errorObj = error.error.errors;

          if (errorObj) {
            this.createNotifications(errorObj);
          }

          throw errorObj;
        })
      );
    } catch {
      return next.handle(request);
    }
  }

  private createNotifications(errors: { key?: string; messages?: string[] }[]): void {
    for (const error of errors) {
      const textToTranslate: string[] = [
        error.key ?? '',
        ...(error.messages ?? []),
      ];

      const notificationService = inject(NzNotificationService);
      const translateService = inject(TranslateService);

      translateService.get(textToTranslate).subscribe(result => {
        notificationService.create(
          'error',
          result[error.key ?? ''] || 'Error',
          error.messages?.reduce((str, err) => {
            if (!err) return '';

            return str + (result[err] ?? err);
          }, '') ?? ''
        );
      });
    }
  }
}